import { getApplicationHeaders, getCurrentCulture, httpClient } from "@utils";
import qs from "qs";
import { BankIdUserInfoDto } from "@api-types/integrations/BankIdUserInfoDto";
import { BankIdWidgetDto } from "@api-types/integrations";
import { BankIdApiAuthDto } from "@api-types/integrations/BankIdApiAuthDto";
import { BankIdSessionStatusDto } from "@api-types/integrations/BankIdSessionStatusDto";

export class BankIdApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/integrations/bankid`;
	}

	private static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();

		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async bankIdApiAuth(
		successRedirectUrl: string,
		failureRedirectUrl: string
	): Promise<BankIdApiAuthDto> {
		const lng = getCurrentCulture() === "sv" ? "sv" : "en";
		const body = {
			language: lng,
			successRedirectUrl,
			failureRedirectUrl,
		};

		return await httpClient.post(
			`${this.baseUrl}/auth/api-authentication`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static async getBankIdWidgetInfo(
		device: "same-device" | "other-device",
		successRedirectUrl: string,
		failureRedirectUrl: string
	): Promise<BankIdWidgetDto> {
		const lng = getCurrentCulture() === "sv" ? "sv" : "en";
		let body = {
			language: lng,
			successRedirectUrl,
			failureRedirectUrl,
		};

		return await httpClient.post(
			`${this.baseUrl}/auth/widget-${device}`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static async getSessionStatus(
		requestId: string,
		isLogin: boolean = false
	): Promise<BankIdSessionStatusDto> {
		return await httpClient.get(
			`${this.baseUrl}/auth/session-status/${requestId}?isLogin=${isLogin}`,
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static async getUserAdditionalInfo(formData: {
		sessionId: string;
	}): Promise<BankIdUserInfoDto> {
		const headers = getApplicationHeaders();
		headers["Content-Type" as keyof HeadersInit] =
			"application/x-www-form-urlencoded";
		return await httpClient.post(
			`${this.baseUrl}/auth/resolve-user-info`,
			qs.stringify(formData),
			headers,
			{ responseType: "json" }
		);
	}
}
